const fields = {
    COMPANY_NAME: {
        isRequired: true,
        text: 'Company Name',
        value: 'companyName'
    },
    COUNTRY_CODE: {
        isRequired: true,
        text: 'Country Code',
        value: 'countryCode'
    },
    EMAIL: {
        isRequired: true,
        text: 'Email',
        value: 'email'
    },
    EXT: {
        isRequired: false,
        text: 'Ext',
        value: 'ext'
    },
    FIRST_NAME: {
        isRequired: true,
        text: 'First Name',
        value: 'firstName'
    },
    LANGUAGE: {
        isRequired: true,
        text: 'Preferred Language',
        value: 'preferredLanguage'
    },
    LAST_NAME: {
        isRequired: true,
        text: 'Last Name',
        value: 'lastName'
    },
    PHONE_NUMBER: {
        isRequired: true,
        text: 'Phone Number',
        value: 'phoneNumber'
    }
}

export const initialValues = {
    companyName: '',
    countryCode: '',
    email: '',
    ext: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    preferredLanguage: ''
}

export default fields
